module.exports = __webpack_public_path__ + "img/tree_add.df5c0b8f.svg";